import React from "react";


const VideoCards = () => {
  const videos = [
    {
        title: "Office comfort",
        channel: "SOLAR CLUB BHARAT",
        url: "https://www.youtube.com/embed/xoLcKeWrBm8",
    },
    {
        title: "Why SOLAR CLUB BHARAT is your deal partner",
        channel: "SOLAR CLUB BHARAT",
        url: "https://www.youtube.com/embed/2GGQV7VgvD4",
    },
    {
        title: "Commit to a profitable future",
        channel: "SOLAR CLUB BHARAT",
        url: "https://www.youtube.com/embed/sCL5ZqS71-o",
    },
    {
        title: "Ensure comfort and productivity",
        channel: "SOLAR CLUB BHARAT",
        url: "https://www.youtube.com/embed/f7o1eS9wyCE",
    },
    
];


    return (
        <div className="container-fluid py-3 bg-light"  >
            <div className="row my-5 g-4">
                {videos.map((video, index) => (
                    <div key={index} className="col-12 col-md-6 col-lg-3">
                        <div className="card shadow-lg rounded-3 border-0 h-100">
                            <div className="ratio ratio-16x9">
                                <iframe
                                    src={video.url}
                                    title={video.title}
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    className="rounded-top"
                                ></iframe>
                            </div>

                            <div className="card-body">
                                <h6 className="card-title fw-semibold">{video.title}</h6>
                                <p className="card-text text-muted small">{video.channel}</p>
                                <button className="btn btn-sm" style={{ backgroundColor: '#07fa38' }}>
                                 <a href="https://www.youtube.com/@swastikengineers7705" style={{color:"black", textDecoration:"none"}}>   <i className="fas fa-bell me-1"></i> Subscribe</a>
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default VideoCards;
